// extracted by mini-css-extract-plugin
module.exports = {"dialog":"CancelPauseDialog_dialog__jFiE6","centerWrapper":"CancelPauseDialog_centerWrapper__yWFCa"};